import _reduce from 'lodash/reduce';
import _pick from 'lodash/pick';

export const formatColumnSettingsStorage = columns => _reduce(
  columns, (result, value, key) => {
    const newResult = result;
    newResult[key] = _pick(value, ['id', 'enabled']);
    return newResult;
  }, {},
);